export { CustomHead } from "./CustomHead";
export { DEFAULT_OG_IMAGE } from "./config";